/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { getWorkHistoryCommuteCalendarList } from "../../../apis/work-history";
import CustomDatePicker from "../../../components/CustomDatePicker";
import classnames from "classnames";
import { getDay, dateToFormat, getWeeksInMonth } from "../../../utils/date";
import { isEmpty } from "lodash-es";
import { findIndex, forEach, includes } from "lodash";
import { toast } from "../../../utils/toast";
import { convertSecondToString } from "../../../utils/work-schedule-calculator";

const MyWorkTime = ({ calendarDate, getPreMonth, getNextMonth }) => {
  // 계획된 시간
  const [originalWorkTime, setOriginalWorkTime] = useState(0);
  // 근무한 날까지의 예정시간
  const [workedDatePlanTime, setWorkedDatePlanTime] = useState(0);
  // 인정시간
  const [admitWorkTime, setAdmitWorkTime] = useState(0);
  // 총 연장 기타 야간
  const [addtionalWorkTime, setAdditionalWorkTime] = useState(0);
  // 기타
  const [otherWorkTime, setOtherWorkTime] = useState(0);
  // 연장
  const [extendWorkTime, setExtendWorkTime] = useState(0);
  // 야간
  const [nightWorkTime, setNightWorkTime] = useState(0);
  const [timePercnet, setTimePercnet] = useState({ width: "0%" });
  const [addtionalTimePercnet, setAdditionalTimePercnet] = useState({
    width: "0%",
  });
  const [lateEarlyLeftTimePercent, setLateEarlyLeftTimePercent] = useState({
    width: "0",
  });
  const [activeTab, setActiveTab] = useState(0);
  const [workTimeDate, setWorkTimeDate] = useState({
    startDate: "",
    endDate: "",
  });
  // 월별 주차 배열
  const [weeksDate, setWeeksDate] = useState([]);
  // 선택된 주
  const [currentWeek, setCurrentWeek] = useState({});
  const [monthLabel, setMonthLabel] = useState("");

  useEffect(() => {
    if (!isEmpty(calendarDate.startDate)) {
      const firstDate = calendarDate.startDate;
      const currentYear = new Date(firstDate).getFullYear();
      const currentMonth = new Date(firstDate).getMonth() + 1;
      const weeksInMonth = getWeeksInMonth(currentYear, currentMonth);
      const weeks = weeksInMonth.map((weeks, idx) => ({
        label: `${currentMonth}월 ${idx + 1}주차`,
        startDate: dateToFormat(
          new Date(currentYear, currentMonth - 1, weeks.start)
        ),
        endDate: dateToFormat(
          new Date(currentYear, currentMonth - 1, weeks.end)
        ),
        dates: weeks.dates
      }));
      setMonthLabel(`${currentMonth}월`);
      setWeeksDate(weeks);
    }
  }, [calendarDate]);

  useEffect(() => {
    // 탭 별 기본값 추가.
    switch (activeTab) {
      case 0:
        // 주별
        if (!isEmpty(weeksDate)) {
          const today = new Date().getDate();
          const todayInWeeksIdx = findIndex(weeksDate, (d) => includes(d.dates, today))

          setCurrentWeek(weeksDate[todayInWeeksIdx]);
          setWorkTimeDate({
            startDate: weeksDate[todayInWeeksIdx].startDate,
            endDate: weeksDate[todayInWeeksIdx].endDate,
          });
        }
        break;
      case 1:
        // 월별
        setWorkTimeDate(calendarDate);
        break;
      case 2:
        // 기간선택
        setWorkTimeDate({
          startDate: getDay(7),
          endDate: getDay(),
        });
        break;
      default:
        break;
    }
  }, [activeTab, weeksDate]);

  useEffect(() => {
    if (!isEmpty(workTimeDate.startDate) && !isEmpty(workTimeDate.endDate)) {
      getWorkGraphData();
    }
  }, [workTimeDate]);

  const tabList = [
    { label: "주별 보기", action: setActiveTab },
    { label: "월별 보기", action: setActiveTab },
    { label: "기간 선택", action: setActiveTab },
  ];

  const getWorkGraphData = () => {
    let totalWorkPlanTimeInSeconds = 0;
    let totalAdmitWorkTimeInSeconds = 0;
    let totalAdditionalWorkTimeInSeconds = 0;
    let totalOtherWorkTimeInSeconds = 0;
    let totalExtendWorkTimeInSeconds = 0;
    let totalNightWorkTimeInSeconds = 0;
    let totalWorkedDatePlanTime = 0;

    getWorkHistoryCommuteCalendarList(workTimeDate).then((res) => {
      const scheduleList = res.data.workScheduleList;
      const historyList = res.data.workHistoryList;
      const transScheduleList = scheduleList.filter(
        ({ date: d1 }) => !historyList.some(({ workDate: d2 }) => d2 === d1)
      );

      forEach(transScheduleList, (s) => {
        if (s.dayType !== 'holiday') {
          totalWorkPlanTimeInSeconds += s.workPlanTimeInSeconds;
        }
      });

      forEach(historyList, (h) => {
        // 근무한 날까지의 근무예정
        if (h.dayType !== 'holiday') {
          totalWorkedDatePlanTime += h.workPlanTimeInSeconds;
          // 근무예정
          totalWorkPlanTimeInSeconds += h.workPlanTimeInSeconds;
        }
        // 인정시간
        totalAdmitWorkTimeInSeconds += h.admitWorkTimeInSeconds;
        // 추가근무 (기타, 연장, 야간)
        totalAdditionalWorkTimeInSeconds += h.otherWorkTimeInSeconds;
        totalAdditionalWorkTimeInSeconds += h.extendWorkTimeInSeconds;
        totalAdditionalWorkTimeInSeconds += h.nightWorkTimeInSeconds;
        // 기타
        totalOtherWorkTimeInSeconds += h.otherWorkTimeInSeconds;
        // 연장
        totalExtendWorkTimeInSeconds += h.extendWorkTimeInSeconds;
        // 야간
        totalNightWorkTimeInSeconds += h.nightWorkTimeInSeconds;

        if (!isEmpty(h.vacations)) {
          forEach(h.vacations, (v) => {
            switch (v.vacationDayType) {
              case "all":
                totalAdmitWorkTimeInSeconds += h.workPlanTimeInSeconds;
                break;
              case "half":
                break;
              case "quarter":
                break;
              case "none":
                break;
              default:
                break;
            }
          });
        }
      });

      setAdmitWorkTime(totalAdmitWorkTimeInSeconds);
      setOriginalWorkTime(totalWorkPlanTimeInSeconds);
      setWorkedDatePlanTime(totalWorkedDatePlanTime);
      setAdditionalWorkTime(totalAdditionalWorkTimeInSeconds);
      setOtherWorkTime(totalOtherWorkTimeInSeconds);
      setExtendWorkTime(totalExtendWorkTimeInSeconds);
      setNightWorkTime(totalNightWorkTimeInSeconds);
    });
  };

  useEffect(() => {
    const totalPlanTime = originalWorkTime + addtionalWorkTime;

    setTimePercnet({
      width: `${Math.floor((admitWorkTime / totalPlanTime) * 100)}%`,
    });

    setAdditionalTimePercnet({
      width: `${Math.floor(
        ((admitWorkTime + addtionalWorkTime) / totalPlanTime) * 100
      )}%`,
    });

    setLateEarlyLeftTimePercent({
      width: `${Math.floor((workedDatePlanTime / totalPlanTime) * 100)}%`,
    });
  }, [admitWorkTime, addtionalWorkTime, originalWorkTime, workedDatePlanTime]);

  const preWeek = () => {
    // 이전 주차
    const currentWeekIndex = findIndex(
      weeksDate,
      (date) => date === currentWeek
    );

    if (currentWeekIndex === 0) return toast.error("달력에서 월을 변경하세요");
    setCurrentWeek(weeksDate[currentWeekIndex - 1]);
    setWorkTimeDate({
      startDate: weeksDate[currentWeekIndex - 1].startDate,
      endDate: weeksDate[currentWeekIndex - 1].endDate,
    });
  };

  const nextWeek = () => {
    // 다음 주차
    const currentWeekIndex = findIndex(
      weeksDate,
      (date) => date === currentWeek
    );

    if (currentWeekIndex === weeksDate.length - 1)
      return toast.error("달력에서 월을 변경하세요");
    setCurrentWeek(weeksDate[currentWeekIndex + 1]);
    setWorkTimeDate({
      startDate: weeksDate[currentWeekIndex + 1].startDate,
      endDate: weeksDate[currentWeekIndex + 1].endDate,
    });
  };

  return (
    <div className="my-work-history-wrap">
      <div className="my-work-history-header">
        <span className="my-work-history-title">나의 근로시간</span>
        <div className="tab-list-wrap">
          <ul className="tab-list">
            {tabList.map((tab, idx) => (
              <li
                key={idx}
                className={classnames("tab-item", {
                  active: activeTab === idx,
                })}
              >
                <a onClick={() => tab.action(idx)}>{tab.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="term-filter-wrap">
          {activeTab === 0 && (
            <div className="weekly-date-wrap">
              <button className="weekly-button pre" onClick={preWeek}>
                <span className="pre" />
              </button>
              <div className="weekly-date">{currentWeek.label}</div>
              <button className="weekly-button next" onClick={nextWeek}>
                <span className="next" />
              </button>
            </div>
          )}
          {activeTab === 1 && (
            <div className="weekly-date-wrap">
              <button className="weekly-button pre" onClick={getPreMonth}>
                <span className="pre" />
              </button>
              <div className="weekly-date">{monthLabel}</div>
              <button className="weekly-button next" onClick={getNextMonth}>
                <span className="next" />
              </button>
            </div>
          )}
          {activeTab === 2 && (
            <CustomDatePicker
              field={{ key: "date" }}
              defaultValue={[workTimeDate.startDate, workTimeDate.endDate]}
              onChange={(date) => {
                if (date.date.length === 2) {
                  setWorkTimeDate({
                    startDate: date.date[0],
                    endDate: date.date[1],
                  });
                }
              }}
            />
          )}
        </div>
      </div>
      <div className="horizontal-divider"></div>
      <div className="my-work-history-body">
        <div className="graph-wrap">
          <div className="graph-text-wrap">
            <p className="graph-text">Total</p>
          </div>
          <div className="graph">
            <div className="graph-back" />
            <div className="graph-mark">
              <div className="admit-work-mark" style={timePercnet} />
              {addtionalWorkTime > 0 && (
                <div
                  className="additional-work-mark"
                  style={addtionalTimePercnet}
                >
                  <span className="tooltiptext">
                    <p className="work-name">
                      기타근무 : {convertSecondToString(otherWorkTime)}
                    </p>
                    <p className="work-name">
                      연장근무 : {convertSecondToString(extendWorkTime)}
                    </p>
                    <p className="work-name">
                      야간근무 : {convertSecondToString(nightWorkTime)}
                    </p>
                  </span>
                </div>
              )}
              <div
                className="late-early-left-work-mark"
                style={lateEarlyLeftTimePercent}
              >
                <span className="tooltiptext">
                  <p className="work-name">
                    {`-${convertSecondToString(
                      workedDatePlanTime - admitWorkTime
                    )}`}
                  </p>
                </span>
              </div>
            </div>
          </div>
          <div className="time-text-wrap">
            <p className="time-text present-time">
              <span className="number">
                {convertSecondToString(admitWorkTime)}
              </span>
              {addtionalWorkTime > 0 && (
                <span className="number additonal-work">
                  {" "}
                  + {convertSecondToString(addtionalWorkTime)}
                </span>
              )}
            </p>
            <p className="time-text total-time">
              <span className="number">
                {convertSecondToString(originalWorkTime)}
              </span>
              {addtionalWorkTime > 0 && (
                <span className="number additonal-work">
                  {" "}
                  + {convertSecondToString(addtionalWorkTime)}
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyWorkTime;
